import React, { MouseEventHandler } from 'react';
import { BtnInterface } from '../../interface/btn-interface';
import { Link } from 'react-router-dom';


const IconButton: React.FC<BtnInterface> = ({ to='', type = 'button', onClick, children, className, disabled }) => {
    let myClass = `p-2 rounded-full hover:bg-gray-100 primary-color hover:text-blue-800`;
    if (className) {
        myClass += ` ${className}`;
    }
    if (disabled) {
        myClass += ' opacity-50 pointer-events-none cursor-not-allowed';
    }

    const handleClick: MouseEventHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            event.preventDefault()
        } 
        else if (onClick) {
            onClick(event);
        }
    };

    if (to) {
        return (
            <Link
                to={to}
                className={myClass}
                tabIndex={disabled ? -1 : undefined}
                aria-disabled={disabled ? 'true' : undefined}
                onClick={handleClick}
            >
                {children}
            </Link>
        );
    } else {    
        return(
            <button
                type={type}
                onClick={onClick}
                className={myClass}
                disabled={disabled}
            >
                {children}
            </button>
        )
    }
};

export default IconButton;
